// Import React and Hooks
import React from 'react'
// Import Redux and Hooks
import { Dispatch } from 'redux'
import { useAppDispatch } from '../../hooks/useRedux'
// Import Actions
import { closeModalAction } from '../../actions/modalAction'
// Import Components
import FloatImg from './FloatImg'
import Button from './Button'



// Modal Message Prop
interface modalMessageProp {
  additionalClass?:string,
  dataModalMessage: {
    id:string,
    isVisible:boolean,
    hasClose:boolean,
    title:string,
    text:string,
    btn: {
      text:string,
      link:string
    } | null
  }
}

const ModalMessage = ( { additionalClass, dataModalMessage }:modalMessageProp ) => {



  // Destructuring
  const { title, text, btn } = dataModalMessage



  // Use Dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  return (
    <section className={`modalMessage ${ additionalClass ? additionalClass : ''}`}>
      <FloatImg
        additionalClass={`flowersModal1`}
        alt="Arreglo floral"
        speed={ 0.013 }
        revert={ true }
        src={`${window.assetsURl}/imgs/shapes/flower-arrangement-6.svg`} />
      <FloatImg
        additionalClass={`flowersModal2`}
        alt="Arreglo floral"
        speed={ 0.008 }
        src={`${window.assetsURl}/imgs/shapes/flower-arrangement-7.svg`} />
      <FloatImg
        additionalClass="petalModal1"
        alt="Pétalo de flor"
        speed={ 0.007 }
        revert={ true }
        src={`${window.assetsURl}/imgs/petals/petal-1.svg`} />
      <FloatImg
        additionalClass="petalModal2"
        alt="Pétalo de flor"
        speed={ 0.009 }
        revert={ true }
        src={`${window.assetsURl}/imgs/petals/petal-3.svg`} />
      <FloatImg
        additionalClass="petalModal3"
        alt="Pétalo de flor"
        speed={ 0.012 }
        src={`${window.assetsURl}/imgs/petals/petal-3.svg`} />
      <FloatImg
        additionalClass="petalModal4"
        alt="Pétalo de flor"
        speed={ 0.012 }
        revert={ true }
        src={`${window.assetsURl}/imgs/petals/petal-4.svg`} />
      <FloatImg
        additionalClass="butterflyModal1"
        alt="Mariposa"
        speed={ 0.014 }
        src={`${window.assetsURl}/imgs/shapes/butterfly-1.svg`} />
      { title && (
        <h2 className="modalMessage__title mb40 mbM20">
          { title }
        </h2>
      ) }
      { text && (
        <p className="modalMessage__text mb45 mbM25">
          { text }
        </p>
      ) }
      { btn && (
        <div className="w100 dF">
          <Button
            additionalClass="btn--default"
            url={ btn.link }
            text={ btn.text }
            functionClick={ (e) => {
              if( btn.link.toLowerCase() === '[reload]' ) {
                e.preventDefault()
                window.location.reload()
              }
              dispatch(closeModalAction () ) }
            } />
        </div>
      ) }
    </section>
  )
}



export default ModalMessage
